import React, { useRef, useState } from "react";
import { QRCodeCanvas } from 'qrcode.react';

const ShopQuickScan = ({ user }) => {
    const qrRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const downloadQR = () => {
        setIsDownloading(true);
        const canvas = qrRef.current;

        if (!canvas) return;

        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");

        const link = document.createElement("a");
        link.href = pngUrl;
        link.download = `${user.shopCode}-QR.png`;
        link.click();
        setIsDownloading(false);
    };

    const copyShopCode = async () => {
        try {
            await navigator.clipboard.writeText(user.shopCode || "JET001");
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <div className="mt-[32px]">
            <div className="bg-white rounded-[16px] border border-[#e4e5e7] p-[24px] md:p-[32px]">

                {/* Header */}
                <div className="flex items-start gap-[16px] mb-[24px]">
                    <div className="w-[44px] h-[44px] rounded-[12px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-[22px] h-[22px] text-[#ff5323]"
                        >
                            <rect width="5" height="5" x="3" y="3" rx="1" />
                            <rect width="5" height="5" x="16" y="3" rx="1" />
                            <rect width="5" height="5" x="3" y="16" rx="1" />
                            <path d="M21 16h-3a2 2 0 0 0-2 2v3" />
                            <path d="M21 21v.01" />
                            <path d="M12 7v3a2 2 0 0 1-2 2H7" />
                            <path d="M3 12h.01" />
                            <path d="M12 3h.01" />
                            <path d="M12 16v.01" />
                            <path d="M16 12h1" />
                            <path d="M21 12v.01" />
                            <path d="M12 21v-1" />
                        </svg>
                    </div>

                    <div>
                        <h3 className="font-semibold text-[18px] text-[#212326] mb-[4px]">
                            QuickScan QR Code
                        </h3>
                        <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                            Print this and display it at your counter. Customers scan it to instantly upload files to your shop.
                        </p>
                    </div>
                </div>

                {/* Body */}
                <div className="flex flex-col md:flex-row items-center gap-[24px]">

                    {/* QR */}
                    <div className="bg-white rounded-[16px] border-2 border-[#e4e5e7] p-[20px] flex flex-col items-center gap-[12px]">
                        <div>
                            <QRCodeCanvas
                                value={`${window.location.origin}/marketplace/upload/?shopCode=${user?.shopCode}`}
                                size={180}
                                level="H"
                                ref={qrRef}
                            />

                            {/* Dummy QR (same SVG you provided) */}
                            {/* <svg height="180" width="180" viewBox="0 0 41 41" role="img">
                                <path fill="#ffffff" d="M0,0 h41v41H0z" shape-rendering="crispEdges"></path>
                                <path fill="#212326"
                                    d="M0 0h7v1H0zM8 0h1v1H8zM10 0h2v1H10zM13 0h2v1H13zM16 0h2v1H16zM19 0h3v1H19zM23 0h2v1H23zM27 0h5v1H27zM34,0 h7v1H34zM0 1h1v1H0zM6 1h1v1H6zM8 1h1v1H8zM15 1h1v1H15zM17 1h1v1H17zM19 1h2v1H19zM22 1h3v1H22zM27 1h2v1H27zM30 1h1v1H30zM32 1h1v1H32zM34 1h1v1H34zM40,1 h1v1H40zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM11 2h1v1H11zM13 2h1v1H13zM15 2h1v1H15zM17 2h1v1H17zM19 2h6v1H19zM26 2h2v1H26zM30 2h2v1H30zM34 2h1v1H34zM36 2h3v1H36zM40,2 h1v1H40zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM8 3h1v1H8zM11 3h2v1H11zM16 3h1v1H16zM18 3h1v1H18zM22 3h1v1H22zM24 3h2v1H24zM28 3h4v1H28zM34 3h1v1H34zM36 3h3v1H36zM40,3 h1v1H40zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM8 4h2v1H8zM15 4h1v1H15zM18 4h3v1H18zM22 4h4v1H22zM27 4h2v1H27zM30 4h1v1H30zM34 4h1v1H34zM36 4h3v1H36zM40,4 h1v1H40zM0 5h1v1H0zM6 5h1v1H6zM8 5h4v1H8zM13 5h1v1H13zM16 5h3v1H16zM21 5h1v1H21zM23 5h1v1H23zM26 5h2v1H26zM29 5h1v1H29zM31 5h2v1H31zM34 5h1v1H34zM40,5 h1v1H40zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18 6h1v1H18zM20 6h1v1H20zM22 6h1v1H22zM24 6h1v1H24zM26 6h1v1H26zM28 6h1v1H28zM30 6h1v1H30zM32 6h1v1H32zM34,6 h7v1H34zM9 7h3v1H9zM13 7h4v1H13zM18 7h2v1H18zM24 7h3v1H24zM29 7h4v1H29zM3 8h1v1H3zM6 8h1v1H6zM9 8h1v1H9zM12 8h1v1H12zM16 8h4v1H16zM21 8h2v1H21zM25 8h3v1H25zM32 8h1v1H32zM35 8h3v1H35zM39,8 h2v1H39zM2 9h1v1H2zM4 9h2v1H4zM8 9h1v1H8zM11 9h1v1H11zM15 9h2v1H15zM20 9h4v1H20zM26 9h1v1H26zM28 9h1v1H28zM32 9h1v1H32zM34 9h1v1H34zM37 9h3v1H37zM0 10h2v1H0zM3 10h8v1H3zM13 10h1v1H13zM15 10h1v1H15zM18 10h3v1H18zM22 10h1v1H22zM24 10h2v1H24zM28 10h1v1H28zM30 10h2v1H30zM35 10h1v1H35zM37 10h3v1H37zM1 11h3v1H1zM5 11h1v1H5zM8 11h2v1H8zM11 11h2v1H11zM14 11h1v1H14zM16 11h2v1H16zM19 11h1v1H19zM21 11h5v1H21zM27 11h2v1H27zM30 11h1v1H30zM33 11h1v1H33zM35 11h2v1H35zM38,11 h3v1H38zM0 12h1v1H0zM4 12h1v1H4zM6 12h3v1H6zM10 12h1v1H10zM12 12h1v1H12zM14 12h1v1H14zM17 12h2v1H17zM22 12h2v1H22zM28 12h2v1H28zM31 12h1v1H31zM34 12h2v1H34zM37 12h1v1H37zM0 13h4v1H0zM9 13h1v1H9zM13 13h4v1H13zM18 13h2v1H18zM21 13h1v1H21zM25 13h3v1H25zM3 14h2v1H3zM6 14h3v1H6zM11 14h2v1H11zM16 14h1v1H16zM21 14h2v1H21zM24 14h1v1H24zM27 14h2v1H27zM30 14h1v1H30zM32 14h1v1H32zM34 14h3v1H34zM38,14 h3v1H38zM1 15h3v1H1zM5 15h1v1H5zM7 15h1v1H7zM9 15h2v1H9zM14 15h2v1H14zM17 15h1v1H17zM19 15h1v1H19zM21 15h2v1H21zM26 15h1v1H26zM28 15h4v1H28zM34 15h1v1H34zM0 16h4v1H0zM6 16h2v1H6zM9 16h3v1H9zM15 16h1v1H15zM17 16h3v1H17zM22 16h1v1H22zM25 16h3v1H25zM29 16h1v1H29zM31 16h2v1H31zM35 16h1v1H35zM37 16h1v1H37zM40,16 h1v1H40zM1 17h1v1H1zM4 17h2v1H4zM9 17h2v1H9zM14 17h2v1H14zM17 17h1v1H17zM19 17h6v1H19zM26 17h1v1H26zM28 17h1v1H28zM30 17h1v1H30zM34 17h2v1H34zM38 17h1v1H38zM40,17 h1v1H40zM0 18h1v1H0zM2 18h2v1H2zM5 18h2v1H5zM9 18h3v1H9zM14 18h3v1H14zM18 18h1v1H18zM21 18h1v1H21zM23 18h1v1H23zM30 18h1v1H30zM33 18h2v1H33zM36 18h1v1H36zM38,18 h3v1H38zM0 19h1v1H0zM2 19h1v1H2zM4 19h2v1H4zM7 19h1v1H7zM9 19h6v1H9zM21 19h4v1H21zM26 19h5v1H26zM33 19h1v1H33zM35 19h1v1H35zM37 19h1v1H37zM39,19 h2v1H39zM1 20h1v1H1zM3 20h1v1H3zM5 20h2v1H5zM8 20h1v1H8zM14 20h1v1H14zM16 20h2v1H16zM19 20h4v1H19zM25 20h2v1H25zM28 20h4v1H28zM34 20h1v1H34zM38 20h1v1H38zM40,20 h1v1H40zM0 21h2v1H0zM8 21h3v1H8zM12 21h5v1H12zM18 21h2v1H18zM21 21h2v1H21zM24 21h3v1H24zM30 21h1v1H30zM32 21h1v1H32zM34 21h2v1H34zM39,21 h2v1H39zM4 22h3v1H4zM8 22h1v1H8zM11 22h1v1H11zM13 22h1v1H13zM19 22h3v1H19zM24 22h1v1H24zM26 22h1v1H26zM28 22h1v1H28zM30 22h3v1H30zM36 22h1v1H36zM38 22h2v1H38zM1 23h1v1H1zM8 23h2v1H8zM11 23h2v1H11zM14 23h1v1H14zM16 23h2v1H16zM22 23h1v1H22zM26 23h2v1H26zM30 23h1v1H30zM38,23 h3v1H38zM4 24h3v1H4zM9 24h3v1H9zM14 24h3v1H14zM18 24h2v1H18zM21 24h2v1H21zM25 24h1v1H25zM28 24h2v1H28zM31 24h5v1H31zM37 24h2v1H37zM40,24 h1v1H40zM0 25h1v1H0zM3 25h1v1H3zM8 25h3v1H8zM19 25h3v1H19zM24 25h2v1H24zM29 25h1v1H29zM31 25h1v1H31zM35 25h1v1H35zM37 25h1v1H37zM39,25 h2v1H39zM0 26h1v1H0zM6 26h1v1H6zM8 26h1v1H8zM10 26h1v1H10zM14 26h1v1H14zM16 26h1v1H16zM18 26h2v1H18zM21 26h1v1H21zM28 26h1v1H28zM32 26h1v1H32zM34 26h1v1H34zM39,26 h2v1H39zM0 27h1v1H0zM2 27h2v1H2zM5 27h1v1H5zM8 27h1v1H8zM12 27h6v1H12zM20 27h1v1H20zM22 27h5v1H22zM28 27h3v1H28zM32 27h1v1H32zM36 27h1v1H36zM0 28h2v1H0zM3 28h2v1H3zM6 28h2v1H6zM13 28h2v1H13zM16 28h2v1H16zM21 28h1v1H21zM23 28h2v1H23zM26 28h4v1H26zM32 28h1v1H32zM35 28h1v1H35zM39,28 h2v1H39zM1 29h1v1H1zM4 29h1v1H4zM7 29h7v1H7zM15 29h1v1H15zM20 29h1v1H20zM23 29h2v1H23zM27 29h1v1H27zM31 29h1v1H31zM33 29h1v1H33zM35 29h1v1H35zM37 29h1v1H37zM39,29 h2v1H39zM0 30h1v1H0zM3 30h1v1H3zM6 30h2v1H6zM9 30h4v1H9zM17 30h1v1H17zM19 30h1v1H19zM21 30h3v1H21zM25 30h2v1H25zM29 30h4v1H29zM37,30 h4v1H37zM2 31h1v1H2zM4 31h2v1H4zM9 31h1v1H9zM12 31h1v1H12zM14 31h2v1H14zM18 31h3v1H18zM22 31h2v1H22zM27 31h7v1H27zM36 31h2v1H36zM0 32h1v1H0zM2 32h2v1H2zM6 32h2v1H6zM14 32h3v1H14zM18 32h1v1H18zM20 32h2v1H20zM23 32h4v1H23zM28 32h1v1H28zM31 32h6v1H31zM38 32h1v1H38zM40,32 h1v1H40zM8 33h1v1H8zM10 33h2v1H10zM14 33h1v1H14zM17 33h3v1H17zM24 33h1v1H24zM26 33h1v1H26zM28 33h1v1H28zM31 33h2v1H31zM36 33h1v1H36zM40,33 h1v1H40zM0 34h7v1H0zM10 34h8v1H10zM20 34h4v1H20zM28 34h2v1H28zM32 34h1v1H32zM34 34h1v1H34zM36 34h1v1H36zM38 34h2v1H38zM0 35h1v1H0zM6 35h1v1H6zM9 35h2v1H9zM16 35h1v1H16zM18 35h3v1H18zM22 35h2v1H22zM26 35h1v1H26zM29 35h1v1H29zM32 35h1v1H32zM36 35h4v1H36zM0 36h1v1H0zM2 36h3v1H2zM6 36h1v1H6zM12 36h3v1H12zM17 36h1v1H17zM20 36h5v1H20zM28 36h1v1H28zM32 36h5v1H32zM39,36 h2v1H39zM0 37h1v1H0zM2 37h3v1H2zM6 37h1v1H6zM8 37h1v1H8zM14 37h1v1H14zM20 37h2v1H20zM25 37h1v1H25zM29 37h1v1H29zM31 37h1v1H31zM33 37h2v1H33zM36 37h2v1H36zM0 38h1v1H0zM2 38h3v1H2zM6 38h1v1H6zM9 38h1v1H9zM14 38h2v1H14zM17 38h1v1H17zM21 38h2v1H21zM24 38h2v1H24zM31 38h1v1H31zM36 38h1v1H36zM40,38 h1v1H40zM0 39h1v1H0zM6 39h1v1H6zM11 39h2v1H11zM14 39h2v1H14zM18 39h1v1H18zM21 39h2v1H21zM27 39h7v1H27zM35 39h1v1H35zM37 39h1v1H37zM39 39h1v1H39zM0 40h7v1H0zM9 40h5v1H9zM15 40h1v1H15zM19 40h3v1H19zM23 40h1v1H23zM27 40h1v1H27zM29 40h1v1H29zM31 40h3v1H31zM35 40h2v1H35zM39 40h1v1H39z"
                                    shape-rendering="crispEdges">

                                </path>
                            </svg> */}
                        </div>

                        <div className="flex flex-col items-center gap-[2px]">
                            <p className="font-semibold text-[14px] text-[#212326]">
                                {user.shopName}
                            </p>
                            <p className="font-mono font-semibold text-[16px] text-[#ff5323] tracking-[3px]">
                                {user.shopCode || "JET001"}
                            </p>
                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="flex-1 flex flex-col gap-[12px] w-full md:w-auto">

                        {/* Shop Code */}
                        <div className="bg-[#fafafa] rounded-[12px] p-[16px] border border-[#e4e5e7]">
                            <p className="font-semibold text-[13px] text-[#212326] mb-[4px]">
                                Your shop code
                            </p>

                            <div className="flex items-center gap-[8px]">
                                <code className="flex-1 font-mono font-semibold text-[20px] text-[#ff5323] tracking-[4px]">
                                    {user.shopCode || "JET001"}
                                </code>

                                <button
                                    onClick={copyShopCode}
                                    className={`flex items-center gap-[6px] px-[12px] py-[6px] rounded-[8px] bg-white border border-[#e4e5e7] font-semibold text-[12px] 
                                    text-[#53585f] hover:border-[#ff5323] hover:text-[#ff5323] transition-colors cursor-pointer
                                    ${isCopied ? "border-[#ff5323] text-[#ff5323]" : ""}`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="w-[14px] h-[14px]"
                                    >
                                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                    </svg>
                                    {isCopied ? "Copied!" : "Copy"}
                                </button>
                            </div>
                        </div>

                        {/* Download Button */}
                        <button
                            disabled={isDownloading}
                            className="w-full flex items-center justify-center gap-[8px] px-[20px] py-[12px] rounded-[12px] bg-[#ff5323] text-white font-semibold text-[14px] hover:bg-[#e64a1f] transition-colors border-none cursor-pointer"
                            onClick={downloadQR}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[16px] h-[16px]"
                            >
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" />
                                <line x1="12" x2="12" y1="15" y2="3" />
                            </svg>
                            {isDownloading ? "Downloading..." : "Download QR Code"}
                        </button>

                        <p className="font-medium text-[12px] text-[#9298a0] leading-[1.5]">
                            Downloads as a high-res PNG ready for printing. Display at your counter, on receipts, or in your shopfront window.
                        </p>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default ShopQuickScan;